import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { useParams } from "react-router-dom";
import { getListingUuidFromUrlParam } from "ui/pages/ThankYou/utils";
import { FEATURE_STATUS } from "features/Account/Account.constants";

export const useCustomFeatureRequest = (config = {}) => {
  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
  const subSectionConfig = sectionConfig[config.key] || {};
  const { listing_uuid } = useParams();
  const listingId = getListingUuidFromUrlParam() || listing_uuid;

  const { handleSectionChange } = useAccountSectionUnlocking();

  const handleRequestClick = () => {
    const payload = {
      listing_uuid: listingId,
      feature_key: config.key,
      feature_value: subSectionConfig?.value,
      feature_status: FEATURE_STATUS.ACCESS_REQUESTED,
    };
    handleSectionChange({
      endPoint: UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL,
      payload,
      status: FEATURE_STATUS.ACCESS_REQUESTED,
    });
  };

  return {
    handleRequestClick,
    subSectionConfig,
  };
};
